import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createMenuRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/menu/category",
    component: lazyRouteComponent(() => import("pages/menu/category")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/menu/supplier",
    component: lazyRouteComponent(() => import("pages/menu/supplier")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/menu/measurement",
    component: lazyRouteComponent(() => import("pages/menu/measurement")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/menu/product",
    component: lazyRouteComponent(() => import("pages/menu/product")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/menu/product/change_price/$id",
    component: lazyRouteComponent(
      () => import("pages/menu/product/change_price"),
    ),
  }),
];
